import { render, staticRenderFns } from "./ResourceSummary.vue?vue&type=template&id=7a7c6c24&scoped=true&"
import script from "./ResourceSummary.vue?vue&type=script&lang=js&"
export * from "./ResourceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ResourceSummary.vue?vue&type=style&index=0&id=7a7c6c24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7c6c24",
  null
  
)

export default component.exports